export default {
  translation: {
    common: {
      emailOrUsername: '邮箱或用户名',
      invalidEmailOrUsername: '错误的邮箱或用户名',
      invalidPassword: '密码错误',
      logInToPlanka: '登录至 Planka',
      noInternetConnection: '没有网络连接',
      pageNotFound_title: '页面找不到',
      password: '密码',
      projectManagement: '项目管理',
      serverConnectionFailed: '服务连接失败',
      unknownError: '未知错误，请稍后重试',
    },

    action: {
      logIn: '登录',
    },
  },
};
